export default {
  FETCH_CASOS: 'FETCH_CASOS',
  FETCH_CASO: 'FETCH_CASO',
  FETCH_MEUS_CASOS: 'FETCH_MEUS_CASOS',
  FETCH_CASOS_DO_SETOR: 'FETCH_CASOS_DO_SETOR',
  FETCH_EXAMES_EM_ANDAMENTO: 'FETCH_EXAMES_EM_ANDAMENTO',
  FETCH_EXAMES_FINALIZADOS: 'FETCH_EXAMES_FINALIZADOS',
  FETCH_EXAMES_SOLICITADOS_DOS_SETORES_DO_USUARIO:
    'FETCH_EXAMES_SOLICITADOS_DOS_SETORES_DO_USUARIO',
  FETCH_EXAME_SOLICITADO: 'FETCH_EXAME_SOLICITADO',
  FETCH_EXAMES_SOLICITADOS_PENDENTES_DOS_SETORES_DO_USUARIO:
    'FETCH_EXAMES_SOLICITADOS_PENDENTES_DOS_SETORES_DO_USUARIO',
  FETCH_EXAMES_SOLICITADOS_EM_ANDAMENTO_DOS_SETORES_DO_USUARIO:
    'FETCH_EXAMES_SOLICITADOS_EM_ANDAMENTO_DOS_SETORES_DO_USUARIO',
  FETCH_EXAMINADORES_CADIDATOS: 'FETCH_EXAMINADORES_CADIDATOS',
  SET_PERMISSAO_ACOES_EXAMINADOR: 'SET_PERMISSAO_ACOES_EXAMINADOR',
  SET_PERMISSAO_ASSUMIR_EXAME: 'SET_PERMISSAO_ASSUMIR_EXAME',
  SET_VESTIGIOS_CASO: 'SET_VESTIGIOS_CASO',
  SET_CADAVERES_CASO: 'SET_CADAVERES_CASO',
  SET_PERICIANDOS_CASO: 'SET_PERICIANDOS_CASO',
  SET_SOLICITACOES_CASO: 'SET_SOLICITACOES_CASO',
  SET_LOCAIS_CASO: 'SET_LOCAIS_CASO',
  AUTORIDADES_REQUISITANTES: 'AUTORIDADES_REQUISITANTES',
  TIPOS_VESTIGIOS: 'TIPOS_VESTIGIOS',
  SET_VESTIGIO_TIMELINE: 'SET_VESTIGIO_TIMELINE',
  OPCOES_USUARIOS: 'OPCOES_USUARIOS',
  TIPOS_VESTIGIOS_ESPECIFICOS: 'TIPOS_VESTIGIOS_ESPECIFICOS',
  TIPOS_VESTIGIOS_GERAIS: 'TIPOS_VESTIGIOS_GERAIS',
  OPCOES_SETORES: 'OPCOES_SETORES',
  FETCH_SOLICITACAO_EXAME: 'FETCH_SOLICITACAO_EXAME',
  TIPOS_SOLICITACOES: 'TIPOS_SOLICITACOES',
  OPCOES_TIPOS_EXAMES: 'OPCOES_TIPOS_EXAMES',
  SET_NECROTERIOS: 'SET_NECROTERIOS',
  FETCH_CARGOS: 'FETCH_CARGOS',
  FETCH_ORGAOS: 'FETCH_ORGAOS',
  FETCH_REGIONAIS: 'FETCH_REGIONAIS',
  FETCH_DIVISOES: 'FETCH_DIVISOES',
  FETCH_SETORES_DIVISAO: 'FETCH_SETORES_DIVISAO',
  FETCH_EXAMES: 'FETCH_EXAMES',
  MODELO_BALISTICO: 'MODELO_BALISTICO',
  FETCH_ITENS_BALISTICOS_GERENCIAVEIS: 'FETCH_ITENS_BALISTICOS_GERENCIAVEIS',
  SET_EXAME_EFICIENCIA: 'SET_EXAME_EFICIENCIA',
  SET_ACTIVE_STEP_EFICIENCIA: 'SET_ACTIVE_STEP_EFICIENCIA',
  SET_EXAME_COMPARACAO_BALISTICA: 'SET_EXAME_COMPARACAO_BALISTICA',
  SET_ACTIVE_STEP_COMPARACAO_BALISTICA: 'SET_ACTIVE_STEP_COMPARACAO_BALISTICA',
  TIPOS_LESOES: 'TIPOS_LESOES',
  CAUSAS_MORTE: 'CAUSAS_MORTE',
  TIPOS_FENOMENOS_CADAVERICOS: 'TIPOS_FENOMENOS_CADAVERICOS',
  SET_PROCESSANDO_EXAME_EFICIENCIA: 'SET_PROCESSANDO_EXAME_EFICIENCIA',
  SET_PROCESSANDO_EXAME_COMPARACAO_BALISTICA: 'SET_PROCESSANDO_EXAME_COMPARACAO_BALISTICA',
  SET_EXAME_GENERICO: 'SET_EXAME_GENERICO',
  SET_ACTIVE_STEP_EXAME_GENERICO: 'SET_ACTIVE_STEP_EXAME_GENERICO',
  SET_PROCESSANDO_EDITOR: 'SET_PROCESSANDO_EDITOR',
  SET_EXAME_REALIZADO_EDITOR_DOCUMENTO: 'SET_EXAME_REALIZADO_EDITOR_DOCUMENTO',
  SESSION_LOGIN_SUCESSO: 'SESSION_LOGIN_SUCESSO',
  SESSION_LOGOUT_TOKEN_EXPIRADO_SUCESSO: 'SESSION_LOGOUT_TOKEN_EXPIRADO_SUCESSO',
  RENEW_SESSION_SUCESSO: 'RENEW_SESSION_SUCESSO',

  // MODELOS DE CLASSIFICAÇÃO BALÍSTICA
  CALIBRE_ARTESANAL_ARMA_DE_FOGO: 'CALIBRE_ARTESANAL_ARMA_DE_FOGO',
  CALIBRE_NOMINAL_ARMA_DE_FOGO: 'CALIBRE_NOMINAL_ARMA_DE_FOGO',
  ESTADO_CONSERVACAO_ARMA_DE_FOGO: 'ESTADO_CONSERVACAO_ARMA_DE_FOGO',
  LOCAL_FABRICACAO_ARMA_DE_FOGO: 'LOCAL_FABRICACAO_ARMA_DE_FOGO',
  LOCAL_GRAVACAO_NUMERACAO_DE_MONTAGEM_ARMA_DE_FOGO:
    'LOCAL_GRAVACAO_NUMERACAO_DE_MONTAGEM_ARMA_DE_FOGO',
  LOCAL_GRAVACAO_NUMERACAO_DE_SERIE_ARMA_DE_FOGO: 'LOCAL_GRAVACAO_NUMERACAO_DE_SERIE_ARMA_DE_FOGO',
  MARCA_ARMA_DE_FOGO: 'MARCA_ARMA_DE_FOGO',
  MODELO_ARMA_DE_FOGO: 'MODELO_ARMA_DE_FOGO',
  SISTEMA_CARREGAMENTO_ARMA_DE_FOGO: 'SISTEMA_CARREGAMENTO_ARMA_DE_FOGO',
  SISTEMA_FUNCIONAMENTO_ARMA_DE_FOGO: 'SISTEMA_FUNCIONAMENTO_ARMA_DE_FOGO',
  SISTEMA_PERCUSSAO_ARMA_DE_FOGO: 'SISTEMA_PERCUSSAO_ARMA_DE_FOGO',
  TIPO_ACABAMENTO_ARMA_DE_FOGO: 'TIPO_ACABAMENTO_ARMA_DE_FOGO',
  TIPO_ALCA_DE_MIRA_ARMA_DE_FOGO: 'TIPO_ALCA_DE_MIRA_ARMA_DE_FOGO',
  TIPO_ALMA_DO_CANO_ARMA_DE_FOGO: 'TIPO_ALMA_DO_CANO_ARMA_DE_FOGO',
  TIPO_ARMA_DE_FOGO: 'TIPO_ARMA_DE_FOGO',
  TIPO_CARREGADOR_ARMA_DE_FOGO: 'TIPO_CARREGADOR_ARMA_DE_FOGO',
  TIPO_CORONHA_ARMA_DE_FOGO: 'TIPO_CORONHA_ARMA_DE_FOGO',
  TIPO_EMPUNHADURA_ARMA_DE_FOGO: 'TIPO_EMPUNHADURA_ARMA_DE_FOGO',
  TIPO_GRAVACAO_ARMA_DE_FOGO: 'TIPO_GRAVACAO_ARMA_DE_FOGO',
  TIPO_GUARDA_MAO_ARMA_DE_FOGO: 'TIPO_GUARDA_MAO_ARMA_DE_FOGO',
  TIPO_MASSA_DE_MIRA_ARMA_DE_FOGO: 'TIPO_MASSA_DE_MIRA_ARMA_DE_FOGO',
  TIPO_MECANISMO_DISPARO_ARMA_DE_FOGO: 'TIPO_MECANISMO_DISPARO_ARMA_DE_FOGO',
  NUMERACAO_DE_MONTAGEM_ARMA_DE_FOGO: 'NUMERACAO_DE_MONTAGEM_ARMA_DE_FOGO',
  NUMERACAO_DE_SERIE_ARMA_DE_FOGO: 'NUMERACAO_DE_SERIE_ARMA_DE_FOGO',
  TIPO_TAMBOR_ARMA_DE_FOGO: 'TIPO_TAMBOR_ARMA_DE_FOGO',
  TIPO_TELHA_ARMA_DE_FOGO: 'TIPO_TELHA_ARMA_DE_FOGO',
  SET_PROCESSANDO_OPCOES: 'SET_PROCESSANDO_OPCOES',
  CALIBRE_NOMINAL_CARTUCHO: 'CALIBRE_NOMINAL_CARTUCHO',
  CALIBRE_CARTUCHO_VARIACAO: 'CALIBRE_CARTUCHO_VARIACAO',
  CAPSULA_ESPOLETAMENTO_CARTUCHO: 'CAPSULA_ESPOLETAMENTO_CARTUCHO',
  FABRICANTE_CARTUCHO: 'FABRICANTE_CARTUCHO',
  TIPO_ESTOJO_CARTUCHO: 'TIPO_ESTOJO_CARTUCHO',
  TIPO_PROJETIL_CARTUCHO: 'TIPO_PROJETIL_CARTUCHO',
  CALIBRE_COMPATIVEL_ELEMENTO_MUNICAO: 'CALIBRE_COMPATIVEL_ELEMENTO_MUNICAO',
  ESPECIE_ELEMENTO_MUNICAO: 'ESPECIE_ELEMENTO_MUNICAO',
  RESSALTOS_E_CAVADOS_ELEMENTO_MUNICAO: 'RESSALTOS_E_CAVADOS_ELEMENTO_MUNICAO',
  NUMERO_LOTE_CARTUCHO: 'NUMERO_LOTE_CARTUCHO',
  TIPO_ELEMENTO_MUNICAO: 'TIPO_ELEMENTO_MUNICAO',
  TIPOS_VESTIGIOS_BALISTICA: 'TIPOS_VESTIGIOS_BALISTICA',
  RESULTADO_EFICIENCIA: 'RESULTADO_EFICIENCIA',
  RESULTADO_CONFRONTO: 'RESULTADO_CONFRONTO',
  CARACTERISTICA_CARTUCHO: 'CARACTERISTICA_CARTUCHO',
  SOLICITAR_REDEFINIR_SENHA_SUCESSO: 'SOLICITAR_REDEFINIR_SENHA_SUCESSO',
  SOLICITAR_REDEFINIR_SENHA_ERROR: 'SOLICITAR_REDEFINIR_SENHA_ERROR',
}
